const GeeqConstants = {
    GEEQ_VERIFY_KEY_B64 : "Fflx2r5FQmmGbGxXE9pB3aeMOXcyN3hdi5DUwdsWnEk=",   // Geeq Corp public key used to sign Genesis block
    UUT_MAX_BLOCK_DELAY : 1000,     // Make it large for simulation    // Maximum delay in saving UUT to specified block number (see spec)
    BLOCK_CACHE_SIZE : 1000  // Make it large for simulation
}

export default GeeqConstants